export default __webpack_public_path__ + "static/media/_소슬러시_ 데일리 컬러 노트 브라운 (줄).f719221f.png";